import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

import {
	handleAsyncThunkActionState,
	initialAsyncState,
	isAsyncThunkActionWithPrefix
} from '../utils';
import {
	createFolder,
	fetchDocuments,
	fetchFolders,
	getFolderById
} from './thunks';

const initialState = {
	isModalErrorOpen: false,
	isModalRateUsOpen: false,
	isModalTimerOpen: false,
	modalErrorCode: '',
	limitedDialog: false,
	searchTerm: '',
	searchFolder: '',
	currentFolder: null,
	folders: [],
	foldersCount: 0,
	createFolderModal: false,
	isEmpty: true,
	page: 1,
	total: 0,
	totalPages: 0,
	transactions: [],
	minutes: dayjs().minute(),
	fetchDocuments: initialAsyncState,
	deleteDocuments: initialAsyncState,
	deleteFolder: initialAsyncState,
	getFolderById: initialAsyncState,
	fetchFolders: initialAsyncState,
	updateFolder: initialAsyncState,
	createFolder: initialAsyncState
};

const myDocumentsSlice = createSlice(
	{
		name: 'myDocuments',
		initialState,
		reducers: {
			clearData() {
				return initialState;
			},
			clearDocuments(state) {
				state.fetchDocuments = initialAsyncState;
				state.transactions = [];
				state.total = 0;
			},
			clearFolders(state) {
				state.fetchFolders = initialAsyncState;
				state.folders = [];
				state.foldersCount = 0;
			},
			setIsModalErrorOpen(state, action) {
				state.isModalErrorOpen = action.payload;
			},
			setIsModalRateUsOpen(state, action) {
				state.isModalRateUsOpen = action.payload;
			},

			setIsModalTimerOpen(state, action) {
				state.isModalTimerOpen = action.payload;
			},
			setModalErrorCode(state, action) {
				state.modalErrorCode = action.payload;
			},
			setPage(state, { payload }) {
				state.page = payload;
			},
			setSearchTerm(state, action) {
				state.searchTerm = action.payload;
			},
			resetDeleteDocumentState(state) {
				state.deleteDocuments = initialAsyncState;
			},
			setSearchFolder(state, action) {
				state.searchFolder = action.payload;
			},
			setCurrentFolder(state, action) {
				state.currentFolder = action.payload;
			},
			setFoldersCount(state, action) {
				state.foldersCount = action.payload;
			},
			setCreateFolderModal(state, action) {
				state.createFolderModal = action.payload;
			},
			setLimitedDialog(state, action) {
				state.limitedDialog = action.payload;
			},
			reloadMinutes(state) {
				state.minutes = dayjs().minute();
			}
		},
		extraReducers(builder) {
			builder.addCase(fetchDocuments.fulfilled, (state, action) => {
				state.isEmpty =
					!action.payload?.transactions?.length &&
					!state.searchTerm &&
					state.page === 1;
				state.total = action.payload?.total;
				state.totalPages = action.payload?.totalPages;
				state.transactions = action.payload?.transactions;
			});
			builder.addCase(fetchFolders.fulfilled, (state, action) => {
				state.folders = action.payload;
				state.foldersCount = action.payload?.length || 0;
			});
			builder.addCase(getFolderById.fulfilled, (state, action) => {
				state.currentFolder = action.payload;
			});
			builder.addCase(createFolder.fulfilled, (state, action) => {
				Object.assign(state, action.payload);
			});
			builder.addMatcher(
				isAsyncThunkActionWithPrefix('myDocuments'),
				handleAsyncThunkActionState()
			);
		}
	},
	initialState
);

export const {
	clearData,
	clearDocuments,
	resetDeleteDocumentState,
	setIsModalErrorOpen,
	setIsModalRateUsOpen,
	setModalErrorCode,
	setIsModalTimerOpen,
	setPage,
	setSearchTerm,
	setSearchFolder,
	setCurrentFolder,
	setFoldersCount,
	setCreateFolderModal,
	setLimitedDialog,
	clearFolders,
	reloadMinutes
} = myDocumentsSlice.actions;

export default myDocumentsSlice.reducer;
